import createMiddleware from './middleware'

export { createMiddleware } // eslint-disable-line
